import styled from 'styled-components';

const HighlightedComponent = styled.span`
  color: #ffc7a6;
  font-weight: bold;
`;
export const HighlightedEditable = HighlightedComponent;
export const HighlightedRenderer = HighlightedComponent;
